var map = {
	"./black.png": 95649,
	"./black_&_green.png": 83930,
	"./black_&_white.png": 2996,
	"./blue_&_white.png": 32423,
	"./blue_&_yellow.png": 83774,
	"./dark_blue.png": 56887,
	"./dark_blue_&_white.png": 67074,
	"./dark_brown_&_white.png": 84794,
	"./dark_green_&_black.png": 39349,
	"./dark_green_&_white.png": 66559,
	"./green_&_white.png": 44860,
	"./grey.png": 5563,
	"./maroon_&_white.png": 22619,
	"./navy_blue_&_white.png": 90310,
	"./purple_&_white.png": 22681,
	"./red.png": 27113,
	"./red_&_black.png": 98122,
	"./red_&_green.png": 35794,
	"./red_&_grey.png": 29218,
	"./red_&_white.png": 66332,
	"./red_&_yellow.png": 94899,
	"./white.png": 20619,
	"./yellow.png": 2090,
	"./yellow_&_black.png": 20989,
	"./yellow_&_brown.png": 86924,
	"./yellow_&_green.png": 68653
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89937;